module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"de":{"search":"Suche","filterByMonths":"Monat","selectYearAll":"Jahr auswählen","deselectYearAll":"Jahr abwählen"},"en":{"search":"Search","filterByMonths":"Months","selectYearAll":"Select year","deselectYearAll":"Deselect year"}}')
  delete Component.options._Ctor
}
